import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Register from './components/Register';
import Home from './components/Home';
import Dashboard from './components/Dashboard';
import Equipment from './pages/Equipment';
import Consumables from './pages/Consumables';
import Teams from './pages/Teams';
import Services from './pages/Services';
import Requests from './pages/Requests';
import RequestDetail from './pages/RequestDetail';
import PrivateRoute from './components/PrivateRoute';
import LocaleProvider from './components/LocaleProvider';
import { isAuthenticated } from './services/authService';
import './App.css';

function App() {
  return (
    <LocaleProvider>
      <Router>
        <Routes>
          <Route
            path="/login"
            element={isAuthenticated() ? <Navigate to="/home" /> : <Login />}
          />
          <Route
            path="/register"
            element={isAuthenticated() ? <Navigate to="/home" /> : <Register />}
          />
          <Route
            path="/"
            element={
              <PrivateRoute>
                <Home />
              </PrivateRoute>
            }
          >
            <Route index element={<Navigate to="/home" />} />
            <Route path="home" element={<Dashboard />} />
            <Route path="requests" element={<Requests />} />
            <Route path="requests/:id" element={<RequestDetail />} />
            <Route path="equipment" element={<Equipment />} />
            <Route path="consumables" element={<Consumables />} />
            <Route path="teams" element={<Teams />} />
            <Route path="services" element={<Services />} />
          </Route>
        </Routes>
      </Router>
    </LocaleProvider>
  );
}

export default App;
